module.exports = __webpack_public_path__ + "img/Haefele_menu1.cdec9c92.png";